import {useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {BackToSiteButton} from '../../common/back-to-site-button'
import {Container} from '../common/container'
import {Subtitle} from '../common/subtitle'
import {Title} from '../common/title'

export const OnlineConferencingStatus = () => {
  const {t} = useTranslation()
  return (
    <Container dataHook="online-conferencing-disabled">
      <div style={{textAlign: 'center'}}>
        <Title text={t('onlineConferencing_disabled_title')} />
        <Subtitle lines={[t('onlineConferencing_disabled_subtitle')]} />
        <BackToSiteButton text={t('onlineConferencing_disabled_buttonText')} />
      </div>
    </Container>
  )
}
